import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import LoadingIndicator from '@/components/LoadingIndicator'
import { TreeView } from '@/components/TreeView'
import { prepareTreeData } from './dataSource'

export class DocumentationTree extends React.Component {
  constructor (props, context) {
    super(props, context)

    const { documentationViewer, download, localize, locale } = props
    const treeItems = ((documentationViewer.tree || {}).external || (documentationViewer.tree || {}).internal) || []
    const treeData = prepareTreeData(treeItems, download, localize, locale)
    this.state = { tree: treeData }
  }
  renderContent () {
    const { documentationViewer, rtl } = this.props
    if (documentationViewer.fetching) { return <LoadingIndicator /> }
    const rowDirection = !rtl ? 'ltr' : 'rtl'

    return (<TreeView
      rowDirection={rowDirection}
      treeData={this.state.tree}
      onChange={x => this.setState({ tree: x })}
      canDrag={false}
    />)
  }
  render () {
    const { localize } = this.props
    return (
      <Main>
        <MainTop>
          <MainTopTitle>{localize('Documentation.DocumentationTitle')}</MainTopTitle>
        </MainTop>
        <MainBody>
          {this.renderContent()}
        </MainBody>
      </Main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/documentationViewer/content.js